export default __webpack_public_path__ + "static/media/me-gusta-153.d6ab1fbb.png";